// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoldOutlinedSvg from "@ant-design/icons-svg/es/asn/GoldOutlined";
import AntdIcon from '../components/AntdIcon';

var GoldOutlined = function GoldOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GoldOutlinedSvg
  }));
};

GoldOutlined.displayName = 'GoldOutlined';
export default React.forwardRef(GoldOutlined);